<ngx-gov-co-shd-app-header-auth>
  <div *ngIf="showViewHTMLComponent" shd-container-router-component>
    <div class="container-shd-component-menu-panel-right">
      <div class="row-shd-component-menu-panel-right">
        <div class="col-main-shd-component-menu-panel-right">
          <nav aria-label="breadcrumb-shd-component-menu-panel-right">
            <ol class="breadcrumb-shd-component-menu-panel-right">
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)">Mis impuestos</a>
              </li>
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)" class="active">Industria y comercio</a>
              </li>
            </ol>
          </nav>
          <div class="container-spec-title-botton">
            <h1 class="page-title-shd-component-menu-panel-right"><b>Industria y comercio</b></h1>
            <button type="button" class="btn-white-secun" (click)="agregarDescuento()">AGREGAR DESCUENTOS</button>
          </div>

          <div class="container-tabs-items">
            <div class="tab-item" [class.active]="tabs[0]" (click)="changeTab(1)" (keydown.enter)="changeTab(1)"   tabindex="0" aria-label="Obligaciones pendientes">
              <span>Obligaciones pendientes</span>
            </div>
            <div class="tab-item" [class.active]="tabs[1]" (click)="changeTab(2)" (keydown.enter)="changeTab(2)" tabindex="0" aria-label="Declaraciones presentadas">
              <span>Declaraciones presentadas</span>
            </div>
          </div>
          <div>
            <app-obligaciones-pendientes *ngIf="tabs[0]"></app-obligaciones-pendientes>
            <app-declaraciones-presentadas-ica *ngIf="tabs[1]"></app-declaraciones-presentadas-ica>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-gov-co-shd-app-header-auth>
<app-agregar-descuento></app-agregar-descuento>